// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { gnosis as _gnosis } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the gnosis chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 100
 * Chain Name: Gnosis
 * Default Block Explorer: https://gnosisscan.io
 * Default RPC URL: https://rpc.gnosischain.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { gnosis } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: gnosis,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const gnosis = createCommon({
	..._gnosis,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
